<template>
    <div style="height: 100%; position: relative;">
        <v-toolbar 
            class="floatingMenuWidth"
            id="floatingAvatarmenu"
            height="42"
            :width="getFloatingMenuWidth()"
            color="#ececec"
            v-resize="onResize"
            floating
        >
            <v-avatar
                class="avatar"
                @click="floatingMenuCollapsed = !floatingMenuCollapsed"
                size="30px"
            >
                <img
                    alt="Avatar"
                    :src="user.IMAGEM_PERFIL ? baseUrl + user.IMAGEM_PERFIL : defaultImage"
                >
            </v-avatar>
            <span v-show="!floatingMenuCollapsed"> {{'Olá' | translate('home')}}, {{user.PRIMEIRO_NOME}}</span>
            <v-btn icon v-show="!floatingMenuCollapsed" @click="goHome()" ><img :src="home" width="18px"> </v-btn>
            <v-btn @click="reload()" icon v-show="!floatingMenuCollapsed" ><img :src="refresh" width="18px"> </v-btn>
            <v-btn icon v-show="!floatingMenuCollapsed" ><img :src="email" width="18px"> </v-btn>
            <v-badge
                :content="notificationsQty"
                :color="notificationsQty ? 'red' : 'transparent'"
                offset-y="20px"
                offset-x="20px"
            >
                <v-btn 
                    class="shake" 
                    v-bind:class="{ active: notify }" 
                    icon 
                    v-show="!floatingMenuCollapsed" 
                    @click="notificationsQty ? expandNotify = !expandNotify : expandNotify = false"
                >
                    <img :src="notification" width="18px"> 
                </v-btn>
            </v-badge>
            <v-btn icon v-show="!floatingMenuCollapsed" @click="getOut()" ><img :src="out" width="18px"> </v-btn>
        </v-toolbar>
        <div class="floatingMenuPositionWarning">
            <v-toolbar
                class="floatingMenuWarning"
                height="22"
                :width="getFloatingMenuWidth() - 16"
                color="#ececec"
                v-resize="onResize"
                floating
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            style="position:relative; left: -10px"
                            v-bind="attrs"
                            v-on="on"
                        >
                            mdi-alert-octagram
                        </v-icon>
                    </template>
                    <span>{{ `Patch ${availablePatch} disponível para atualização!` | translate('home') }}</span>
                </v-tooltip>
                <span  style="width: 89%;" v-show="!floatingMenuCollapsed">{{ `Patch ${availablePatch} disponível para atualização!` | translate('home') }}</span>
            </v-toolbar>
            <v-toolbar
                v-for="warning in warnings"
                class="floatingMenuWarning"
                height="22"
                :width="getFloatingMenuWidth() - 16"
                color="#ececec"
                v-resize="onResize"
                floating
                :key="warning.position"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            style="position:relative; left: -10px"
                            v-bind="attrs"
                            v-on="on"
                        >
                            mdi-alert-octagram
                        </v-icon>
                    </template>
                    <span>{{warning.TEXTO | translate('home')}}</span>
                </v-tooltip>
                <span  style="width: 89%;" v-show="!floatingMenuCollapsed">{{warning.TEXTO | translate('home')}}</span>
            </v-toolbar>
        </div>
        <v-expand-transition class="expandPannel">
            <v-card
                v-if="expandNotify"
                height="auto"
                :width="getFloatingMenuWidth()"
                class="expandPannel"
                elevation="11"
                @mouseleave="expandNotify = false"
            >
                <v-card-title style="background-color:rgb(240, 240, 240);">{{'Não lidas' | translate('home')}}</v-card-title>
                <v-divider/>
                <v-card-text style="padding: 6px 0px;">
                    <div class="scrollnotification">
                        <v-list-item style="padding: 0 4px;" v-for="notification in notificationsPage" :key="JSON.stringify(notification)" three-line>
                            <v-card class="notifyCard" elevation="4">
                                <div class="hoverCard" @click="goto(notification.LINK)">
                                    <v-card-title>{{notification.TITULO | translate('home')}} - {{notification.ID_ATENDIMENTO}}</v-card-title>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12" md="4">
                                                <v-avatar size="18">
                                                    <img :src="notification.subject.IMAGEM_PERFIL ? baseUrl + notification.subject.IMAGEM_PERFIL : defaultImage">
                                                </v-avatar>
                                                <span style="margin-left:8px;">{{notification.subject.NOME}}</span>
                                            </v-col>
                                            <v-col cols="12" md="8">
                                                <v-chip 
                                                    class="chipChat" 
                                                    small 
                                                    color="green"
                                                    text-color="white"
                                                >
                                                    <v-avatar left>
                                                        <v-icon>
                                                            mdi-calendar
                                                        </v-icon>
                                                    </v-avatar>
                                                    {{notification.DATA_HORA}}
                                                </v-chip>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-text style="padding: 8px; text-align: initial;" v-if="notification.LOG_SISTEMA == 'S'">
                                        <v-row>
                                            <v-col cols="12" md="10">
                                                <v-list-item v-for="value in notification.TEXTO" :key="JSON.stringify(value)">
                                                    <v-list-item-content style="padding:0;">
                                                        <v-list-item-title>
                                                            {{value.label | translate('Atendimento')}}
                                                        </v-list-item-title>
                                                            <v-list-item-subtitle>{{value.oldValue}}  
                                                                <v-icon>
                                                                    mdi-arrow-right
                                                                </v-icon>
                                                                {{value.newValue}}
                                                            </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </div>
                                <v-card-actions>
                                    <v-row>
                                        <v-col cols="12" md="10" style="text-align: right;">
                                            <v-btn
                                                icon
                                                plain
                                                @click="updateViewsById(notification.ID)"
                                            >
                                                <v-icon>mdi-eye-check</v-icon>
                                                <span>Marcar como lido</span> 
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-actions>
                            </v-card>
                        </v-list-item>
                    </div>
                    <div class="text-center">
                        <v-pagination
                            v-model="page"
                            :length="notifications.length"
                            circle
                            :total-visible="6"
                        ></v-pagination>
                    </div>
                </v-card-text>
            </v-card>
        </v-expand-transition>
        <v-navigation-drawer
            class="menuDrawer"
            v-model="drawer"
            :mini-variant="mini"
            :width="widthNavbar()"
            v-resize="onResize"
            v-click-outside="closeDrawer"
            @mousedown="''"
            permanent
            absolute
            color="#ececec"
            app
        >
            <header class="menuHeader">
                <img :src="logoCrm" :width="navBarPinned ? 160 : 60">
            </header>
            <v-divider></v-divider>
            <v-list class="menuList" max-height="68%" v-resize="onResize">
                <!-- NÃO DELETAR ESSES ITENS, POIS SERÃO USADOS FUTURAMENTE. Pedido 51496 val 25282 -->
                <!-- <v-list-item to="/dashboard">
                    <v-list-item-icon>
                        <img :src="dashboard" width="26px">
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="text-left">
                            {{'Dashboard' | translate('home')}}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item> -->
                <v-list-item to="/atendimentos">
                    <v-list-item-icon>
                        <img :src="atendimentos" width="26px">
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="text-left">
                            {{'Atendimentos' | translate('home')}}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/pedidos" v-if="!user.CLIENTE_ID">
                    <v-list-item-icon>
                        <img :src="pedidos" width="26px">
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="text-left">
                            {{'Pedidos' | translate('home')}}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <!-- <v-list-item to="/projeto">
                    <v-list-item-icon>
                        <img :src="projeto" width="26px">
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="text-left">
                            {{'Projeto' | translate('home')}}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item> -->
                <!-- <v-list-item to="/CRMVendas">
                    <v-list-item-icon>
                        <img :src="CRMVendas" width="26px">
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="text-left">
                            {{'Crm de Vendas' | translate('home')}}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item> -->
                <v-list-item to="/clientes" v-if="!user.CLIENTE_ID">
                    <v-list-item-icon>
                        <img :src="administrativo" width="26px">
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="text-left">
                            {{'Administrativo' | translate('home')}}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/empresa" v-if="!user.CLIENTE_ID">
                    <v-list-item-icon>
                        <img :src="ajustes" width="26px">
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="text-left">
                            {{'Ajustes' | translate('home')}}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item to="/minhaconta">
                    <v-list-item-icon>
                        <img :src="minhaConta" width="26px">
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="text-left">
                            {{'Minha Conta' | translate('home')}}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <footer class="menuFooter">
                <span v-if="navBarPinned">{{'Versão' | translate('home')}} 1.0.0</span>
            </footer>
        </v-navigation-drawer>
        <v-container style="height:100%; width:100%" class="pa-0 ma-0" fluid>
            <v-slide-x-transition hide-on-leave>
                <router-view></router-view>
            </v-slide-x-transition>
        </v-container>
        <v-bottom-navigation
            class="footer"
            horizontal
            permanent
            scroll-threshold="200"
        >
            <v-row>
                <v-col
                    xs="2" sm="4" md="2" lg="2" xl="2"
                    style="padding-top:0"
                >
                    <v-select
                        class="languageSelect"
                        v-model="changedlanguage"
                        :items="idiomas"
                        item-text="DESCRICAO"
                        item-value="ID"
                        :label="selectLabel"
                        return-object
                        single-line
                        height="10"
                        @change="changeLanguage(changedlanguage)"
                    >
                        <template v-slot:selection="{ item }">
                            <span>{{ item.DESCRICAO | translate('Home') }}</span>
                        </template>
                        <template v-slot:[`item`]="{ item }">
                            <span>{{ item.DESCRICAO | translate('Home') }}</span>
                        </template>
                    </v-select>
                </v-col>
                <v-spacer/>
                <div style="margin-right: 2em; display: flex;">
                    <span style="margin-top:7px;">
                        {{'Copyright © 2022 Kunden Systems. Todos os direitos reservados.'| translate('Home')}}
                    </span>
                </div>
            </v-row>
        </v-bottom-navigation>
        <v-btn
            icon
            class="floatingBtn elevation-6"
            fab
            small
            @click="navBarPinned = !navBarPinned"
        >
            <v-icon>mdi-menu</v-icon>
        </v-btn>
        <banner-modal 
            @closeModal="closeModal()" 
            @getWarning="getWarning()"
            :open="this.showBanner" 
            :url="this.bannerModalUrl" 
            :banner="this.banner"
        ></banner-modal>
        
    </div>
</template>

<script>
import getAllLanguages from '../../src/app/idioma/getAllLanguages'
import translate from '../../src/plugins/translate'
import { createNamespacedHelpers } from 'vuex'
import getNotificationsByUser from '../../src/app/notificacao/getNotificationsByUser'
import socketService from '../../src/plugins/socketIo'
import loadWarning from '../../src/app/aviso/loadWarning'
import updateUserCompany from '../../src/app/empresa_usuario/updateUserCompany'
import updateViewsById from '../../src/app/mensagemAtendimento/statusMensagemAtendimento/updateViewsById'
import BannerModal from '../../src/components/bannerModal.vue'
import getAvailablePatch from '../../src/app/patch/getAvailablePatch'
const user = createNamespacedHelpers('user')
const socketIo = createNamespacedHelpers('socketIo')
const filters = createNamespacedHelpers('callFilters')
const warning = createNamespacedHelpers('warning')


export default {
    name: 'Home',
    components : {
        bannerModal : BannerModal
    },
    data() {
        return {
            drawer: true,
            mini: false,
            exitDialog: false,
            floatingMenuCollapsed: false,
            navBarPinned: false,
            baseUrl: process.env.VUE_APP_API_URL,
            windowSize: {},
            changedlanguage: null,
            languageSelected: null,
            // changedlanguage: JSON.parse(localStorage.getItem('language')),
            // languageSelected: JSON.parse(localStorage.getItem('language')),
            selectLabel: translate('Selecione', 'homePage'),
            idiomas: [],
            logoCrm: require('../../src/assets/LogoKundenCrm.png'),
            atendimentos: require('../../src/assets/menu/atendimentos.png'),
            pedidos: require('../../src/assets/menu/pedidos.png'),
            projeto: require('../../src/assets/menu/projeto.png'),
            CRMVendas: require('../../src/assets/menu/crm.png'),
            administrativo: require('../../src/assets/menu/administrativo.png'),
            ajustes: require('../../src/assets/menu/ajustes.png'),
            minhaConta: require('../../src/assets/menu/minha_conta.png'),
            dashboard: require('../../src/assets/menu/dashboard.png'),
            home: require('../../src/assets/notifications/home_image.png'),
            refresh: require('../../src/assets/notifications/refresh_image.png'),
            email: require('../../src/assets/notifications/email_image.png'),
            notification: require('../../src/assets/notifications/notification_image.png'),
            out: require('../../src/assets/notifications/out_image.png'),
            pin: require('../../src/assets/notifications/pin_image.png'),
            defaultImage: require('../../src/assets/user.png'),
            notify: false,
            expandNotify: false,
            warnings: [],
            showBanner : false,
            bannerModalUrl : null,
            banner: {},
            availablePatch: null,
            page: 1,
        };
    },
    watch:{
        notifications(){
            var shake = localStorage.getItem('shake') || 'N'
            if(shake != 'S') return 
            this.notify = true
            setTimeout(function(){
                this.notify = false
            }.bind(this),1000)
        }
    },
    methods: {
        ...user.mapActions(['setUser']),
        ...filters.mapActions(['setFilters', 'setFilterOptions', 'setFilterValues']),
        ...warning.mapGetters(['getStoreWarning']),
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            this.floatingMenuCollapsed = !this.getWidhtWindow()
        },
        closeModal(){
            this.showBanner = false
        },
        widthNavbar() {
            if (this.navBarPinned) return 240 
            else return this.windowSize.x < 680 ? 0 : 64
        },
        getWidhtWindow(){
            return this.windowSize.x > 390 ? true : false
        },
        getFloatingMenuWidth(){
            if(this.floatingMenuCollapsed) return 46
            else return 320 + (this.user.PRIMEIRO_NOME ? this.user.PRIMEIRO_NOME.length *6 : 20)
        },
        getFloatingMenuHeight(){
            if(this.floatingMenuCollapsed) return 44
            else return 280
        },
        getOut() {
            localStorage.clear()
            this.setFilters({
                ID:{label:'ID', title:translate('Nº', 'AtendimentosTable'), values:[]},
                ACAO_COM_USUARIO_ID: {label:'ACAO_COM_USUARIO_ID', title:translate('Ação Com', 'AtendimentosTable'), values:[], exception: false},
                CLIENTE_ID: {label:'CLIENTE_ID', title:translate('Cliente', 'AtendimentosTable'), values:[], exception: false},
                DATA_INICIO: {label:'DATA_INICIO', title:translate('Dt. Ini.', 'AtendimentosTable'), values:[]},
                DATA_LIMITE: {label:'DATA_LIMITE', title:translate('Dt. Limite', 'AtendimentosTable'), values:[]},
                SOLICITANTE_ID: {label:'SOLICITANTE_ID', title:translate('Solicitante', 'AtendimentosTable'), values:[], exception: false},
                RESPONSAVEL_ID: {label:'RESPONSAVEL_ID', title:translate('Responsável', 'AtendimentosTable'), values:[], exception: false},
                SITUACAO_ID: {label:'SITUACAO_ID', title:translate('Situação', 'AtendimentosTable'), values:[], exception: false},
                NAO_LIDOS: {label:'NAO_LIDOS', title:translate('Não lidos', 'AtendimentosTable'), values:[]},
                TEXTO_MENSAGEM: {label: 'TEXTO_MENSAGEM', title:translate('Termo mensagem', 'AtendimentosTable'), values:[]},
                SETOR_ID: {label: 'SETOR_ID', title:translate('Setor', 'AtendimentosTable'), values:[], exception: false},
            })
            this.setFilterValues([])
            this.setUser()
            this.setFilterOptions({
                clients: [],
                responsibles: [],
                calls: [],
                callRequesters: [],
                callResponsibles: [],
                situations: [],
                sections: []
            })
            this.$router.push('/')
        },
        async changeLanguage(changedlanguage) {
            if(!changedlanguage || (this.languageSelected && this.languageSelected.ID == changedlanguage.ID)) return
            this.languageSelected = changedlanguage ? changedlanguage : this.languageSelected
            localStorage.setItem('language', JSON.stringify(this.languageSelected || null))
            this.user.language = this.languageSelected
            localStorage.setItem('user', JSON.stringify(this.user))
            this.setUser()
            updateUserCompany(this.user).then(() => window.location.reload())
        },
        goHome() {
            if(window.location.href.includes('/dashboard')) return 
            this.$router.push('/dashboard')
        },
        closeDrawer(event) {
            if (event.target.className.includes('floatingBtn')) return
            if (event.target.className.includes('mdi-menu')) return
            this.navBarPinned = false
        },
        goto(link){
            this.$router.push(link)
        },
        async getWarning(){
            this.loading = true
            await loadWarning(this.user.EMPRESA_ID, this.user.USUARIO_ID)
                .then(function(response){
                    this.$store.dispatch('warning/setWarning', response.data.warning)
                    this.displayBannerMsg(response.data)
                    this.warnings = this.getStoreWarning()
                }.bind(this))
                .finally(this.loading = false)
        },
        async getAvailablePatch(){
            await getAvailablePatch()
                .then(function(response){
                    this.availablePatch = response.data.PATCH
                }.bind(this))
        },
        async updateViewsById(id){
            this.$store.dispatch('socketIo/alreadyRead', id)
            await updateViewsById({userId:this.user.USUARIO_ID, id, factoryUserId:this.user.EMPRESA_USUARIO_ID})
        },
        displayBannerMsg(data){
            if(data.banner.name){
                let userType = this.user.CLIENTE_ID ? 'client' : 'operator'
                let userAdmin = this.user.ADM == 'S' ? 'administrator' : 'nonAdministrator'
                this.banner = data.banner
                if(data.banner[userType] && data.banner[userAdmin] && !localStorage.getItem('bannerAlreadyShown')){
                    this.showBanner = true
                    this.bannerModalUrl = this.baseUrl + data.banner.url + data.banner.name 
                }
            } 
        },
        reload(){
            window.location.reload()
        }
    },
    computed:{
        ...user.mapGetters(['user']),
        ...socketIo.mapGetters(['notifications']),
        notificationsPage(){
            return this.notifications[this.page - 1]
        },
        notificationsQty(){
            return this.notifications.length > 1
                ? this.notifications.reduce((accum, cur) => {
                    if(typeof accum === 'number') return accum + cur.length
                    else return accum.length + cur.length
                })
                : this.notifications.length ? this.notifications[0].length : 0
        }
    },
    async mounted() {
        this.loading = true
        console.log(this.user)
        this.onResize() 
        await this.getAvailablePatch()
        await this.getWarning()

        localStorage.setItem('user', JSON.stringify(this.user ? this.user : {}))
        this.setUser()

        socketService(this.user)
        setTimeout(function(){
            getNotificationsByUser(this.user.EMPRESA_USUARIO_ID)
        }.bind(this),400)
        this.loading = true
        await getAllLanguages('actives', this.user.EMPRESA_ID)
            .then(function(response){
                this.idiomas = response.data
                localStorage.setItem('idiomas', JSON.stringify(this.idiomas))
                if(this.user.language) {
                    this.languageSelected = this.user.language
                    this.changedlanguage = this.user.language
                    localStorage.setItem('language', JSON.stringify( this.languageSelected ))
                }
            }.bind(this))
            .finally(this.loading = false)
    },
}
</script>
<style scoped>
.btn1{
    border-radius: 6px;
}
.item{
    padding-left: 1rem;
    padding-right: 1rem;
    text-transform: none;
}
.menuHeader{
    height: 18%;
    max-height: 18%;
    display: flex;
    align-items: center;
    justify-content: initial;
}
.menuHeader > img {
    padding-left: 5%;
}
.menuList{
    height: 68%;
    scrollbar-width: thin;
    overflow: auto;
    padding: 0px !important;
}
.menuList::-webkit-scrollbar {
    width: 8px;
}

.menuList::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.menuList::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}
.menuFooter{
    height: 10%;
    max-height: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.footer{
    position:fixed !important;
    /* display: flex; */
    align-items: center;
    border-top: 1px solid #cfcfcf;
    background-color: #ececec !important;
    height: 30px !important;
    z-index:1001;
}
.footer > .row {
    height: inherit; 
}
.floatingMenuWidth{
    position: absolute;
    right: 8px;
    top: 8px;
    border-radius: 25px;
    z-index: 1001;
}
.floatingMenuPositionWarning{
    position: absolute;
    right: 8px;
    top: 60px;
}
.floatingMenuWarning{
    display: flex;
    border-radius: 25px;
    z-index: 100;
    margin-bottom: 0.3rem;
}
.floatingMenuHeigth{
    position: fixed;
    right: 8px;
    top: 8px;
    border-radius: 25px;
    z-index: 1001;
}
.verticalMenuItems{
    position: relative;
    height: inherit;
    padding: 8px 0px 8px 0px;
    left: -18px;
}

.avatar{
    position: relative;
    right: 8px;
}
.avatar:hover{
    cursor: pointer;
}
.floatingBtn{
    background-color: #ececec !important;
    position: fixed;
    left: 12px;
    bottom: 7%;
    z-index: 1002;
}

.languageSelect{
    padding-left:20px; 
    font-size:12px;
}

.menuDrawer{
    height: 100% !important;
    z-index: 1000;
    position: fixed;
}

.blockHover:hover{
    cursor: not-allowed;
}

.shake.active{
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-2px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-2px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(2px, 0, 0);
  }
}

.expandPannel{
    position: absolute;
    right: 44px;
    top: 60px;
    z-index: 100;
    max-height: 400px;
}
.scrollnotification{
    max-height: 324px;
    overflow: auto;
    /* border: 1px solid #979797;
    border-radius: 10px 5px 5px 10px; */
}

.scrollnotification::-webkit-scrollbar {
    width: 8px;
}

.scrollnotification::-webkit-scrollbar-track {
    background-color: #e4e4e4;
    border-radius: 20px;
}

.scrollnotification::-webkit-scrollbar-thumb {
    border-radius: 20px;
    background-color: rgb(187, 187, 187);
}

.notifyCard{
    margin:2px; 
    width:100%
}
.hoverCard:hover{
    background-color: rgb(240, 240, 240);
    cursor: pointer;
}
.floatingMenuPositionWarning >>> header{
    white-space: nowrap;
    max-width: 99%;
    overflow: hidden;
    text-overflow: ellipsis;
}
@media only screen and (max-width: 539px){
    .menuHeader{
        height: 16%;
        max-height: 16%;
    }
    .languageSelect{
        padding-left:60px; 
        font-size:12px;
    }
    .floatingBtn{
        left:4px;
        bottom: 7.6%;
    }
}
@media only screen and (min-width: 540px) and (max-width: 739px){
    .menuList{
        height: 60%;
        max-height: 60%;
    }
    .languageSelect{
        padding-left:60px; 
        font-size:12px;
    }
    .floatingBtn{
        left:4px;
    }
}
@media only screen and (min-width: 601px) and (max-width: 820px){
    .container{
        padding-left: 6em;
    }
}
@media only screen and (min-width: 760px) and (max-width: 980px){}
@media only screen and (min-width: 980px) and (max-width: 1026px){}
@media only screen and (min-width: 1026px) and (max-width: 1280px){}
@media only screen and (min-width: 1360px) and (max-width: 1439px){}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1440px) and (max-width: 1640px) {}
@media only screen and (max-device-width: 480px) and (orientation:portrait) {}
@media only screen and (min-width: 1640px) and (max-width: 1980px) {}
</style>